import axios from "../axios/index.js";

const urlCreateContact = "/api/contact/create";

export default {
    create(params) {
        return axios.post(urlCreateContact, params);
    },
}
